import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// PARTS
import Table from 'parts/table/Table';

// MAIN COMPONENT
const Gross = ({ value }) => (
  <span className={clsx(value > 0 && 'text-success', value < 0 && 'text-danger')}>
    {value !== null && <Table.Dollars>{value}</Table.Dollars>}
  </span>
);

// EXPORT
export default Gross;
